import React from "react";
import Footer from "../common/Footer";
import Header from "../common/header";
import Subbanner from "./Banner";
import CasualGamesList from "./CasualGameList"; // ✅ no .ts or .tsx in import

const CasualGames: React.FC = () => {
  return (
    <div className="w-full h-full">
      <Header />
      <Subbanner height="30vh" />
      <CasualGamesList />
      <Footer />
    </div>
  );
};

export default CasualGames;
